module.exports = __webpack_public_path__ + "static/media/dumbbell.73bbbba0.jpg";